import ApiService from "@/common/api/api.service";

const Detalhes = {

    salvar: function(form) {
        return ApiService.post("ProjetoGestao", form);
    },

};

export default Detalhes;